module.exports = __webpack_public_path__ + "static/media/report.abf1b721.jpg";